import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-dropdown', 'close', 'Close pop-up window');
Labels.set('ui-dropdown', 'closeLang', 'Close language select');
Labels.set('ui-dropdown', 'openLang', 'Open language select');

Labels.set('ui-dropdown', 'eng', 'English');
Labels.set('ui-dropdown', 'est', 'Estonian');
Labels.set('ui-dropdown', 'lat', 'Latvian');
Labels.set('ui-dropdown', 'lit', 'Lithuanian');
Labels.set('ui-dropdown', 'rus', 'Russian');
